export const faqs = [
  {
    question: "投稿会暴露我的身份吗？",
    answer:
      "不会。投稿通道默认匿名，联系方式为选填项；编辑在核实线索时会隐去所有可能指向投稿人的信息，未经你同意不会对外披露身份。",
  },
  {
    question: "什么样的线索值得投稿？",
    answer:
      "与公共利益相关、有可核实细节的线索最有价值，例如消费维权、行业内部操作、职场与用工问题等。请尽量附上时间、地点、经过与可佐证的材料。",
  },
  {
    question: "投稿之后多久会有回应？",
    answer:
      "编辑团队通常在 1 至 3 个工作日内完成初筛；若线索需要进一步核实，会通过你留下的联系方式主动联系。",
  },
  {
    question: "我可以撤回投稿吗？",
    answer:
      "可以。在内容正式发布前，你随时可以通过原投稿通道留言要求撤回，我们会立即中止处理并删除相关材料。",
  },
  {
    question: "投稿有报酬吗？",
    answer:
      "平台不以报酬换取不实信息；对于价值重大且被采用的深度线索，我们会与投稿人另行沟通致谢方式。",
  },
  {
    question: "平台如何核实线索真实性？",
    answer:
      "编辑会通过交叉比对公开信息、寻找多方信源、要求补充证据等方式核实；未能证实的部分不会作为事实表述。",
  },
  {
    question: "为什么有些线索没有被发布？",
    answer:
      "涉及人身安全、隐私保护、证据不足或存在法律风险的内容，我们会暂缓或放弃发布，这是对投稿人与当事人的双重保护。",
  },
];